export default __webpack_public_path__ + "static/media/place.3af237c5.svg";